module.exports = __webpack_public_path__ + "img/puzzle_34.7e6144b8.png";